// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2pZuN","validationTips":"StatementDescriptor_validationTips__11iut"};